export function hashMap<T, K>(items: T[], getKey: (item: T) => K): Map<K, T> {
  const map = new Map<K, T>();

  for (const item of items) {
    map.set(getKey(item), item);
  }

  return map;
}
